<template>
  <div class="footer-sidebar center">
    <slot></slot>
    <vs-button
      class="primary mt-2 mb-3"
      @click="logout"
      icon="logout"
      type="filled"
      id="btnbackover"
    >
      <h6 class="stfont">Log Out</h6>
    </vs-button>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$session.clear();
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>